import React from 'react';
import privacyData from '../privacypolicy.json';
import PolicyLayout from './PolicyLayout';

const PrivacyPolicy = () => {
  return <PolicyLayout data={privacyData} />;
};

export default PrivacyPolicy;
